import { LogOut } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { clearAdminAuthSession } from '@/utils/deviceFingerprint';
import { useToast } from '@/hooks/use-toast';

export function LogoutButton() {
  const { toast } = useToast();

  const handleLogout = async () => {
    try {
      await clearAdminAuthSession();
      toast({
        title: 'Logged Out',
        description: 'You have been logged out successfully.',
      });
      // Force reload to trigger security gate
      window.location.reload();
    } catch (error) {
      console.error('[LogoutButton] Logout error:', error);
      toast({
        title: 'Error',
        description: 'Failed to logout. Please try again.',
        variant: 'destructive',
      });
    }
  };

  return (
    <Button variant="ghost" onClick={handleLogout} className="gap-2">
      <LogOut className="h-4 w-4" />
      Logout
    </Button>
  );
}
